import apiHeader from '@/helpers/apiHeader';

const extendFormService = {
    save(id, params) {
        return apiHeader.post(`request-pool/extend/save/${id}`, params);
    },
};

export default extendFormService;
